import { MESFMain } from "@dexteel/mesf-core";
import "react-datepicker/dist/react-datepicker.css";
import "react-markdown-editor-lite/lib/index.css";
import { render } from "react-dom";
import "./app.css";
import "./setup/ag-grid-license";

import { AuthenticationConfig } from "@setup/auth-config";
import { customConfigurations } from "@setup/configurations";
import { CustomNavbar } from "@setup/navbar";
import { CustomRoutes } from "@setup/routes";

import { themeMESF } from "@dexteel/mesf-core";
import { ThemeProvider as StylesThemeProvider } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

// Create MUI v6 compatible theme
const muiTheme = createTheme({
	palette: {
		mode: "light",
		primary: {
			main: "#D4822A",
			light: "#BF6E00",
			dark: "#8C4A00",
			contrastText: "#ffffff",
		},
		secondary: {
			main: "#A0002B",
			light: "#800020",
			dark: "#5D0017",
			contrastText: "#ffffff",
		},
		background: {
			default: "#F2F2F2",
		},
	},
});

// Update themeMESF for backward compatibility
themeMESF.palette = {
	...themeMESF.palette,
	mode: "light",
	primary: {
		main: "#D4822A",
		light: "#BF6E00",
		dark: "#8C4A00",
		contrastText: "#ffffff",
	},
	secondary: {
		main: "#A0002B",
		light: "#800020",
		dark: "#5D0017",
		contrastText: "#ffffff",
	},
	background: {
		default: "#F2F2F2",
		paper: "#FFFFFF",
	},
};

const logbookSettings = {
	entry: {
		// Standard logbook entry settings
		allowAttachments: true,
		canEditShift: true,
		showShiftCrew: true,
		exportToExcel: true,
		shiftsRange: 7,
		// Asset configuration - show asset column and selector
		withAssetFilter: "tree" as const, // Show asset column in grid
		canEditAsset: true, // Show asset selector in entry viewer
		// Section configuration - enables section features in the logbook
		section: {
			enabled: true,
			topSectionsCount: 5,
			showSectionColumn: true, // Show section column in grid
			showSectionFilter: true, // Show section multi-select filter
			showSectionSelector: true, // Show section selector in entry viewer
		},
	},
	report: {
		showAttachments: true,
		showAsset: true,
		showShiftCrew: true,
		exportToExcel: true,
		// Section configuration for report
		section: {
			enabled: true,
			showSectionColumn: true,
			showSectionFilter: true,
		},
	},
	section: {
		schema: "SWV",
		enabled: true,
		withAssetFilter: undefined,
		filterAssets: undefined,
		canEditAsset: false,
		allowAttachments: true,
		showShiftCrew: true,
		exportToExcel: true,
		topSectionsCount: 5,
	},
};

render(
	<StylesThemeProvider theme={muiTheme}>
		<MESFMain
			routes={CustomRoutes}
			navbar={CustomNavbar}
			showAreaSelector={true}
			showTrendingsIcon={false}
			showTrendingsV2Icon={false}
			navbarTitle={"SWV CMMS"}
			configurations={customConfigurations}
			authentication={AuthenticationConfig}
			logbookSettings={logbookSettings}
			plantAssetId={0}
		/>
	</StylesThemeProvider>,
	document.getElementById("root"),
);
